import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
//import { AuthContext } from '../helpers/AuthContext';

function CreatBataillon() {
  
  const [listUser, setListUsers] = useState([]);
  const [listeBrigade, setListeBrigade] = useState([]);
  const navigate = useNavigate();

  const initialValues = {
    name: '',
    libelle: '',
    observation: '',
    reference: '',
    implantation: '',
    historique: '',
    userId: '',
    brigadeId: '', // ajouter ceci
  };

  useEffect(() => {
    axios.get('/brigade').then((res) => {
      setListeBrigade(res.data);
    });
  }, []);

  useEffect(() => {
    try {
      axios.get('/auth').then((response) => {
        setListUsers(response.data);      
       });
    } catch (error) {
    console.error('Erreur lors de la récupération des utilisateurs :', error);
  }

  }, []);


  const enregistrer = (data) => {
    axios
      .post('/bataillon', data)
      .then((response) => {
        toast.success('Bataillon enregistré avec succès !');
        navigate('/bataillon');
      })
      .catch((error) => {
        toast.error("Erreur lors de l'enregistrement !");
        console.error(error);
      });
  };

  const validation = Yup.object().shape({
    name: Yup.string().required('Veuillez remplir le name'),
    libelle: Yup.string().required('Veuillez remplir le libelle'),
    observation: Yup.string(),
    reference: Yup.string(),
    implantation: Yup.string(),
    historique: Yup.string(),
  });

  return (
    <React.Fragment>
      <div className="container mt-5 pt-5">
        <h1 className='bg-warning pt-3 text-center' >Enregistrement nouveau "Bataillon"</h1>
        <Formik enctype="multipart/form-data" initialValues={initialValues} onSubmit={enregistrer} validationSchema={validation}>
          <Form>
            <div className="row">
              <div className="col">
                <label htmlFor="name">Bataillon : </label>
                <ErrorMessage className="text-danger" name="name" component="span" />
                <Field autocomplete="off" id="name" name="name" className="form-control" />
              </div>
              <div className="col">
                <label htmlFor="libelle">Libellé :</label>
                <ErrorMessage className="text-danger" name="libelle" component="span" />
                <Field autocomplete="off" id="libelle" name="libelle" className="form-control" />
              </div>
              <div className="col">
                <label htmlFor="observation">Observation :</label>
                <ErrorMessage className="text-danger" name="observation" component="span" />
                <Field autocomplete="off" id="observation" name="observation" className="form-control" />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label htmlFor="implantation">Implantation : </label>
                <ErrorMessage className="text-danger" name="implantation" component="span" />
                <Field autocomplete="off" id="implantation" name="implantation" className="form-control" />
              </div>
              <div className="col">
                <label htmlFor="historique">Historique :</label>
                <ErrorMessage className="text-danger" name="historique" component="span" />
                <Field as="textarea" id="historique" name="historique" className="form-control" />
              </div>
              <div className="col">
                <label htmlFor="reference">Référence :</label>
                <ErrorMessage className="text-danger" name="reference" component="span" />
                <Field autocomplete="off" id="reference" name="reference" className="form-control" />
              </div>
              <div className="col-md-4">
                <label htmlFor="brigade">Brigade : </label>
                <ErrorMessage className="text-danger" name="brigade" component="span" />
             <Field as="select" id="brigadeId" name="brigadeId" className="form-control">
              <option value=""></option>
              {listeBrigade.map((brigade, key) => (
                <option key={key} value={brigade.id}>
                  {brigade.name}
                </option>
              ))}
            </Field>
              </div>
            </div>

              <div className="col-md-4">
                <label htmlFor="user">Utilisateur responsable : </label>
                <ErrorMessage className="text-danger" name="user" component="span" />
                  <Field as="select" id="userId" name="userId" className="form-control">
                    <option value=""></option>
                    {listUser.map((user, key) => {
                      return (
                        <option key={key} value={user.id}>
                          {user.username} {/* Utilise .username si c'est le nom dans la base */}
                        </option>
                      );
                    })}
                  </Field>
              </div>


            <div className="row">
              <div className="col">
                <button type="submit" className="btn btn-success mt-4">
                  Enregistrer
                </button>
              </div>
            </div>
          </Form>
        </Formik>
      </div>
    </React.Fragment>
  );
}

export default CreatBataillon;
